import React from 'react';
import { 
  FaHome, 
  FaBuilding, 
  FaTruck, 
  FaRoad,
  FaBox,
  FaClipboardCheck,
  FaArrowRight
} from 'react-icons/fa';
import { Link } from 'react-scroll';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: <FaHome />,
      title: "Déménagement maison",
      description: "Déménagement de particulier en toute sérénité. Emballage, transport et installation.",
      features: ["Emballage professionnel", "Montage/Démontage", "Assurance incluse"],
      price: "Sur devis",
      color: "#3b82f6"
    },
    {
      icon: <FaBuilding />,
      title: "Déménagement bureau",
      description: "Solutions adaptées aux entreprises avec un minimum de perturbation.",
      features: ["Devis personnalisé", "Week-end possible", "Matériel adapté"],
      price: "Sur devis",
      color: "#8b5cf6"
    },
    {
      icon: <FaTruck />,
      title: "Transport de meubles",
      description: "Transport sécurisé de vos biens précieux avec suivi en temps réel.",
      features: ["Camion capitonné", "Suivi GPS", "Assurance tous risques jusqu'à 20 000€"],
      price: "Sur devis",
      color: "#f59e0b"
    },
    {
      icon: <FaRoad />,
      title: "Transport longue distance",
      description: "Déménagement national et international avec une équipe expérimentée.",
      features: ["Suivi en ligne", "Formalités douanières", "Équipe dédiée"],
      price: "Sur devis",
      color: "#10b981"
    }
  ];

  return (
    <section className="services" id="services">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">NOS SERVICES</span>
          <h2 className="section-title">
            Des solutions sur mesure pour<br />
            <span className="text-gradient">tous vos besoins</span>
          </h2>
          <p className="section-description">
            Que vous déménagiez votre maison, votre bureau ou que vous ayez besoin 
            de transporter des meubles, nous avons la solution adaptée.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card" style={{ '--card-color': service.color }}>
              <div className="card-header">
                <div className="icon-wrapper" style={{ background: `${service.color}15` }}>
                  <span style={{ color: service.color }}>{service.icon}</span>
                </div>
                <span className="price-tag">{service.price}</span>
              </div>

              <h3>{service.title}</h3>
              <p className="service-description">{service.description}</p>

              <ul className="service-features">
                {service.features.map((feature, i) => (
                  <li key={i}>
                    <FaClipboardCheck className="check-icon" />
                    {feature}
                  </li>
                ))}
              </ul>

              <Link 
                to="contact" 
                smooth={true} 
                duration={500}
                className="service-link"
              >
                Demander un devis
                <FaArrowRight className="link-icon" />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;